module.exports = __webpack_public_path__ + "static/media/fooda.ac327e72.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fooda.jpeg
// module id = 211
// module chunks = 0